<template>
  <div class="sidebar">
    <div class="fixed">
      <v-footer absolute class="footer">
        <v-layout justify-center fluid row wrap>
          <v-flex xs11 class="logo-container">
            <img class="cardano-logo" src="../assets/cardano-logo.png" />
          </v-flex>
          <v-flex xs11>
            <user-info @on-change-password="openDialog('CHANGE_PASSWORD')" @on-logout="handleLogout"></user-info>
          </v-flex>
          <v-flex xs12 class="company">Powered by ScanTrust™</v-flex>
        </v-layout>
      </v-footer>

<!-- Left this commented to use later when we may have dialogs -->
<!-- 
      <v-dialog :width="formWidth[dialog]" :value="dialog" :persistent="true">
        <v-card>
          <component v-if="dialog === 'FARM'"
            :certificates="this.$route.params && this.$route.params.certificates ? this.$route.params.certificates : []"
            :farm="this.$route.params && this.$route.params.farm ? this.$route.params.farm : {}"
            :farm-id="this.$route.params && this.$route.params.id ? this.$route.params.id : null"
            @on-close-dialog="handleCloseDialog('farms')"
            :is="formComponents['FARM']">
          </component>
        </v-card>
      </v-dialog> -->
    </div>
  </div>
</template>

<script>

import CustomFabBtn from '@/components/CustomFabBtn'
import UserInfo from '@/components/UserInfo'

import { mapGetters } from 'vuex'

export default {
  name: 'Sidebar',
  props: {
    type: String
  },
  computed: mapGetters({
    profile: 'profile'
  }),
  data () {
    return {
      dialog: false
    }
  },
  components: {
    'custom-fab-btn': CustomFabBtn,
    'user-info': UserInfo
  },
  methods: {
    openDialog (type) {
      this.dialog = type
    },

    handleCloseDialog (route) {
      this.dialog = false
      this.$router.push({ name: route })
    },

    handleLogout () {
      this.$store.dispatch('logout')
    }
  },
}
</script>

<style lang="scss" scoped>
.sidebar{
  width: 320px;
  background: #fafafa;
  // padding: 0 17px;
  position: relative;
  .fixed{
    position: fixed;
    top: 6%;
    bottom: 0;
    width: 320px;
    .footer{
      height: auto !important;
      font-size: 14px;
      background: none;
      .logo-container{
        text-align: center;
        .cardano-logo{
          margin: 30px;
          width: 200px;
        }
      }
      .company{
        color: #1f5fac;
        font-style: italic;
        text-align: center;
        margin: 31px auto 29px;
      }
    }
  }
}
</style>
